import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="legal-container">
            <div className="legal-card">
                <button onClick={() => navigate(-1)} className="back-link">← {t('back', 'Voltar')}</button>
                <h1>{t('privacy_policy_title', 'Política de Privacidade')}</h1>
                <p className="last-updated">{t('last_updated', 'Última atualização')}: 22 de Janeiro de 2026</p>

                <section>
                    <h2>1. Coleta de Informações</h2>
                    <p>Coletamos informações que você nos fornece diretamente ao criar uma conta, como nome, e-mail e dados de perfil do Instagram para artistas.</p>
                </section>

                <section>
                    <h2>2. Uso de Dados</h2>
                    <p>Utilizamos seus dados para personalizar sua experiência, facilitar a comunicação entre clientes e artistas e melhorar nossas ferramentas de gestão.</p>
                </section>

                <section>
                    <h2>3. Compartilhamento de Informações</h2>
                    <p>Não vendemos seus dados pessoais. Informações de perfil público e portfólio são compartilhadas com outros usuários para possibilitar a conexão entre as partes.</p>
                </section>

                <section>
                    <h2>4. Segurança</h2>
                    <p>Empregamos medidas técnicas de segurança para proteger seus dados contra acesso não autorizado ou vazamentos.</p>
                </section>

                <section>
                    <h2>5. Cookies</h2>
                    <p>Utilizamos cookies para manter sua sessão ativa e entender como você interage com nossa plataforma.</p>
                </section>

                <section>
                    <h2>6. Seus Direitos</h2>
                    <p>Você pode solicitar a exclusão de sua conta e de todos os dados associados a qualquer momento através das configurações de perfil.</p>
                </section>

                <section>
                    <h2>7. Contato</h2>
                    <p>Para dúvidas sobre sua privacidade, entre em contato através do nosso canal de suporte oficial.</p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
